import { createContext, Dispatch, ReducerAction, useContext, useReducer } from 'react';

type PasswordRecoveryReducerActionType = 'NEXT_STEP' | 'PREV_STEP';
type PasswordRecoveryReducerState = { step: number; email?: string };

const passwordRecoveryReducer = (
  state: PasswordRecoveryReducerState,
  action: {
    type: PasswordRecoveryReducerActionType;
    payload?: Omit<PasswordRecoveryReducerState, 'step'>;
  },
) => {
  const newState = { ...state, ...action.payload };

  switch (action.type) {
    case 'NEXT_STEP': {
      if (state.step === 2) return { ...newState, step: 2 };

      return { ...newState, step: state.step + 1 };
    }
    case 'PREV_STEP': {
      if (state.step === 0) return { ...newState, step: 0 };

      return { ...newState, step: state.step - 1 };
    }
    default:
      return state;
  }
};

type PasswordRecoveryContextProps = {
  state: PasswordRecoveryReducerState;
  dispatch: Dispatch<ReducerAction<typeof passwordRecoveryReducer>>;
};

const PasswordRecoveryContext = createContext<PasswordRecoveryContextProps>({
  state: { step: 0 },
  dispatch: () => {},
});

export const PasswordRecoveryProvider = ({ children }) => {
  const [state, dispatch] = useReducer(passwordRecoveryReducer, { step: 0 });
  return (
    <PasswordRecoveryContext.Provider value={{ state, dispatch }}>
      {children}
    </PasswordRecoveryContext.Provider>
  );
};

export const usePasswordRecovery = () =>
  useContext<PasswordRecoveryContextProps>(PasswordRecoveryContext);
